import styled from "@emotion/styled";
import React from "react";
import { CustomThemeType } from "../../context/Providers";

const ButtonWrapper = styled.button<{ theme?: CustomThemeType }>`
  background-color: color-mix(in hsl, ${(p) => p.theme.ctaColor}, white 0%);
  color: ${(p) => p.theme.ctaContrast};
  padding: 2rem 3rem;
  border-radius: 0.5rem;
  font-family: "Inter";
  font-size: 1.5rem;
  &:hover {
    background-color: color-mix(in hsl, ${(p) => p.theme.ctaColor}, black 20%);
  }
  @media (max-width: 450px) {
    font-size: 1rem;
    padding: 1.5rem;
  }
`;
interface CallToActionButtonProps {
  children: any;
  onClick: (e: any) => any;
}

const CallToActionButton: React.FC<CallToActionButtonProps> = ({
  children,
  onClick,
}) => {
  return <ButtonWrapper onClick={(e) => onClick(e)}>{children}</ButtonWrapper>;
};

export default CallToActionButton;
